import React, { useState } from 'react';
import { ShieldCheck, Menu, X, Flag, Search } from 'lucide-react';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  return <header className="w-full flex flex-col shadow-sm sticky top-0 z-50 bg-white" data-id="element-65">
      {/* Government Top Bar */}
      <div className="bg-gov-navyDark text-white py-1.5 px-4 sm:px-6 lg:px-8 text-xs font-medium flex justify-between items-center" data-id="element-66">
        <div className="flex items-center space-x-2 max-w-7xl mx-auto w-full" data-id="element-67">
          <Flag className="w-3.5 h-3.5 text-gray-300" data-id="element-68" />
          <span data-id="element-69">Official Website of Franklin County Government</span>
        </div>
      </div>

      {/* Main Header */}
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center" data-id="element-70">
        {/* Logo / Seal Area */}
        <div className="flex items-center space-x-3" data-id="element-71">
          <div className="bg-gov-navy p-2 rounded-full flex items-center justify-center" data-id="element-72">
            <ShieldCheck className="w-8 h-8 text-gov-amber" data-id="element-73" />
          </div>
          <div className="flex flex-col" data-id="element-74">
            <span className="text-sm font-bold text-gov-slate uppercase tracking-wider leading-tight" data-id="element-75">
              Franklin County
            </span>
            <span className="text-xl font-serif font-black text-gov-navy leading-tight" data-id="element-76">
              Department of Public Health
            </span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center space-x-8" data-id="element-77">
          <a href="#home" onClick={e => {
          e.preventDefault();
          window.location.hash = '';
          window.scrollTo(0, 0);
        }} className="text-gov-navy font-semibold hover:text-gov-amber transition-colors cursor-pointer" data-id="element-78">
            Home
          </a>
          <a href="#services" className="text-gov-slate font-medium hover:text-gov-navy transition-colors" data-id="element-79">
            Services
          </a>
          <a href="#about" className="text-gov-slate font-medium hover:text-gov-navy transition-colors" data-id="element-80">
            About Us
          </a>
          <a href="#contact" className="text-gov-slate font-medium hover:text-gov-navy transition-colors" data-id="element-81">
            Contact
          </a>

          <div className="flex items-center space-x-4 pl-4 border-l border-gray-200" data-id="element-82">
            <button aria-label="Search" className="text-gov-slate hover:text-gov-navy transition-colors" data-id="element-83">
              <Search className="w-5 h-5" data-id="element-84" />
            </button>
            <a href="#report" className="bg-gov-amber hover:bg-gov-amberHover text-gov-navyDark font-bold py-2 px-4 rounded shadow-sm transition-all" data-id="element-85">
              Report a Concern
            </a>
          </div>
        </nav>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-gov-navy p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-86">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-87" /> : <Menu className="w-6 h-6" data-id="element-88" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 px-4 pt-2 pb-6 space-y-1 shadow-lg absolute top-full left-0 w-full" data-id="element-89">
          <a href="#home" onClick={e => {
        e.preventDefault();
        window.location.hash = '';
        window.scrollTo(0, 0);
      }} className="block px-3 py-3 text-base font-semibold text-gov-navy rounded-md hover:bg-gray-50 cursor-pointer" data-id="element-90">
            Home
          </a>
          <a href="#services" className="block px-3 py-3 text-base font-medium text-gov-slate rounded-md hover:bg-gray-50" data-id="element-91">
            Services
          </a>
          <a href="#about" className="block px-3 py-3 text-base font-medium text-gov-slate rounded-md hover:bg-gray-50" data-id="element-92">
            About Us
          </a>
          <a href="#contact" className="block px-3 py-3 text-base font-medium text-gov-slate rounded-md hover:bg-gray-50" data-id="element-93">
            Contact
          </a>
          <div className="pt-4 pb-2" data-id="element-94">
            <a href="#report" className="block w-full text-center bg-gov-amber hover:bg-gov-amberHover text-gov-navyDark font-bold py-3 px-4 rounded shadow-sm transition-all" data-id="element-95">
              Report a Concern
            </a>
          </div>
        </div>}
    </header>;
}